import { Component, ViewChild } from "@angular/core";
import { KpiHostComponent } from "../dashboardCommon/components/kpiHost.component";
import { ProfileType, ImpersonationService } from "../auth/apigee/impersonation.service";

@Component({
    selector: "static-dashboard-definition",
    templateUrl: "./staticDashboardDefinition.component.html",
    standalone: false
})
export class StaticDashboardDefinitionComponent {
    // Call to action
    // Clients
    public get callToActionPastPendingOrdersHostVisible(): boolean {
        return true;
    }
    public get callToActionInmediatePendingOrdersHostVisible(): boolean {
        return true;
    }
    public get callToActionInmediatePendingOrdersTEAHostVisible(): boolean {
        return true;
    }
    public get callToActionInmediatePendingOrdersPermHostVisible(): boolean {
        return true;
    }
    // Talent
    public get callToActionWorkersAppealPendingVisible(): boolean {
        return true;
    }
    public get callToActionPendingOrderFDVisible(): boolean {
        return true;
    }
    public get callToActionCandidatesBucketStatusHostVisible(): boolean {
        return true;
    }
    public get callToActionDiscontinuousPermanentWorkersHostVisible(): boolean {
        return true;
    }
    // Management & Control
    public get callToActionPastUnsignedContractsHostVisible(): boolean {
        return true;
    }
    public get callToActionInmediateUnsignedContractsHostVisible(): boolean {
        return true;
    }
    public get callToActionActiveWorkersWoPPEHostVisible(): boolean {
        return true;
    }
    public get callToActionMoreManagementControlKpisVisible(): boolean {
        return true;
    }
    public get callToActionInmediateExpiringContractsHostVisible(): boolean {
        return true;
    }

    // Clients
    // Atraction
    public get clientsVisitsCallsEvolutionHostVisible(): boolean {
        return true;
    }
    public get clientsVisitsPerformedHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.Consultant;
    }
    public get clientsVisitsPerformedDOHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.OfficeManager;
    }
    public get clientsCallsPerformedHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.Consultant;
    }
    public get clientsCallsPerformedDOHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.OfficeManager;
    }
    public get clientsOffersInNegotiationExtendedHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.Consultant;
    }
    public get clientsOffersInNegotiationEvolutionDOHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.OfficeManager;
    }
    public get clientsOfferingsPerformedHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.Consultant;
    }
    public get clientsOfferingsPerformedDOHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.OfficeManager;
    }
    public get clientsHangoutsPerformedHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.Consultant;
    }
    public get clientsHangoutsPerformedDOHostVisible(): boolean {
        return this.impersonationService.currentProfileType == ProfileType.OfficeManager;
    }
    // Fidelization
    public get clientsPastExpiringOrdersHostVisible(): boolean {
        return true;
    }
    public get clientsInmediateExpiringOrdersHostVisible(): boolean {
        return true;
    }

    // Talent
    // Attraction
    public get talentCandidatesBucketStatusDetailHostVisible(): boolean {
        return true;
    }
    public get discontinuousPermanentWorkersHostVisible(): boolean {
        return true;
    }

    // Management & Control
    // Contract signing
    public get managementControlPastUnsignedContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlInmediateUnsignedContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlForecastUnsignedContractsHostVisible(): boolean {
        return true;
    }
    // Contract expirations
    public get managementControlPastExpiringContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlInmediateExpiringContractsHostVisible(): boolean {
        return true;
    }
    public get managementControlForecastExpiringContractsHostVisible(): boolean {
        return true;
    }
    // Risks
    public get managementControlActiveWorkersWoPPEHostVisible(): boolean {
        return true;
    }
    public get managementControlPendingActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlExpiredActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlProcessingActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlFitActiveWorkersWoMedicalExaminationHostVisible(): boolean {
        return true;
    }
    public get managementControlAbsencesHostVisible(): boolean {
        return true;
    }
    // E-Solutions
    public get managementControlClientsWoESolutionHostVisible(): boolean {
        return true;
    }
    // Esolutions bulletins
    public get managementControlClientsWoBulletinsHostVisible(): boolean {
        return true;
    }

    @ViewChild('callToActionPastPendingOrdersHost') public tourKpi: KpiHostComponent;

    constructor(private impersonationService: ImpersonationService) { }

    public get dashboardOwner(): string {
        return this.impersonationService.isImpersonating ? this.impersonationService.getUserDisplayName() : "";
    }
}
